import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';

const model = {
  state: {
    // 多商户申请列表
    queryParams: {
      pageSize: 10,
      page: 1,
      storeType: -1,
      showTest: 0,
      subShopId: null,
      shopPhone: null,
      businessStatus: null,
    },
    list: [],
    listTotal: 0,
    agentTotal: 0,
    listLoading: false,

    applyList: [],
    applyListTotal: 0,
    applyListLoading: false,

    // 多商户分组列表
    groupQueryParams: {
      per_page: 10,
      cur_page: 1,
    },
    groupList: [],
    groupTotal: 0,
    groupLoading: false,

    unionShopList: [], // 入驻聚合平台的店铺列表
    ruleText: '', // 聚合平台入驻规则
    feeScale: null, // 服务费比例
    iscountModalVisible: false,
    batchDeliveryModalVisible: false,
    batchEditAllModalVisible: false,
    editFeeModalVisible: false,
    selectedRowKeys: [],
    businessCategoryList: [],
    batchBusinessAttributeModalVisible: false,
    complaintRecordModalVisible: false,
    auditMerchantDeliveryVisible: false, // 商家自配审核弹窗
    cityList: [], // 城市列表
    logisticsValuationVisible: false,
    valuationData: [],
    environmentVisible: false, // 环保标签弹窗
    quickpaySettingModalVisible: false, // 到店付弹窗设置
    hardWareList: [], // 硬件绑定列表
    hardWareListTotal: 0,
    hardWarePageParams: {
      page: 1,
      pageSize: 20,
    },
    hardWareListDetail: {},
    hardWareListLoading: false,
    bindHardWareLoading: false,
    shopId: 0,
    merchantToBeDeliveredNum: 1, // 商家待配送数量
    subShopId: 0,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { shopPolymerManage, basic }, getState }) => ({
    // 更新选中数组
    updateselectedRowKeys(selectedRowKeys, selectedRow = []) {
      shopPolymerManage.setState({ selectedRowKeys: selectedRowKeys });
      shopPolymerManage?.getBusinessCategory(selectedRow);
    },
    /**
     * 根据选中城市获取品类
     */
    async getBusinessCategory(selectedRow) {
      const cityCodeList = selectedRow.map((item) => {
        return item.cityCode;
      });
      shopPolymerManage.setState({
        businessCategoryList: [],
      });
      if (cityCodeList.length) {
        const data = await fetch('/saasmerchant/web/shop/getBusinessCategory', {
          type: 'POST',
          useJson: true,
          params: {
            cityCodeList,
          },
        });
        if (data) {
          shopPolymerManage.setState({
            businessCategoryList: data?.list || [],
          });
        }
      }
    },
    // 获取门店管理列表
    async getList() {
      const { queryParams } = getState().shopPolymerManage;
      const { coordinate, ...params } = queryParams;
      shopPolymerManage.setState({ listLoading: true });
      if (params.fs_delivery_status === '-1') {
        delete params.fs_delivery_status;
      }
      /**
       * 增加默认值
       */
      if (coordinate) {
        params.latitude = coordinate?.split('-')[0];
        params.longitude = coordinate?.split('-')[1];
      }
      params.showTest = params?.showTest ?? 0;

      const data = await fetch('/saasmerchant/web/bms/business/shop/list', {
        type: 'POST',
        useJson: true,
        params: { ...filterNull(params), isExport: 0 },
      });
      if (data) {
        shopPolymerManage.setState({
          list: data.list,
          listTotal: data.total,
          totalNum: data.totalNum,
          needAuditNum: data.needAuditNum,
          saasNeedAuditNum: data.saasNeedAuditNum,
          merchanteedAuditNum: data.merchanteedAuditNum,
          activateFlagNum: data.activateFlagNum,
          agentTotal: data.agent_count,
          listLoading: false,
          isExport: 0,
          merchantToBeDeliveredNum: data.needAuditNum,
        });
      } else {
        shopPolymerManage.setState({ listLoading: false });
        message.error('获取店铺申请信息失败');
      }
    },
    // 门店管理导出列表
    async onExport() {
      const { queryParams } = getState().shopPolymerManage;
      const { coordinate, ...params } = queryParams;
      // 导出不分tab页的数据
      const {
        filterAuditStatus,
        filterMerchantDeliveryAuditStatus,
        filterSaasLogisticalAuditStatus,
        ...restParams
      } = params;
      const data = await fetch('/saasmerchant/web/bms/business/shop/shopexport', {
        type: 'POST',
        useJson: true,
        params: { ...restParams, isExport: 1 },
        getAllResponseData: true,
      });
      console.log('data', data);
      if (data?.data) {
        basic.setLogListDot(true);
        message.success('导出成功');
      } else {
        message.error(data?.errmsg || '导出失败');
      }
    },
    // 门店管理搜索列表
    onSearch(queryParams) {
      if (Number(queryParams.merchantDeliveryStatus) === 0)
        delete queryParams.merchantDeliveryStatus;

      if (Number(queryParams.merchantDeliveryAuditStatus) === -1)
        delete queryParams.merchantDeliveryAuditStatus;
      shopPolymerManage.setState({ queryParams });
      shopPolymerManage.getList();
    },
    // 多商户申请列表底部换页
    onNav(page) {
      const { queryParams } = getState().shopPolymerManage;
      shopPolymerManage.setState({
        queryParams: { ...queryParams, page },
      });
      shopPolymerManage.getList();
    },
    onListSizeChange(current, pageSize) {
      const { queryParams } = getState().shopPolymerManage;
      shopPolymerManage.setState({
        queryParams: {
          ...queryParams,
          pageSize,
        },
      });
      shopPolymerManage.getList();
    },
    // 多商户申请列表重置筛选项
    onReset() {
      shopPolymerManage.setState({
        queryParams: {
          pageSize: 10,
          page: 1,
          storeType: -1,
          subShopId: null,
          shopPhone: null,
          businessStatus: null,
          cityName: '',
          showTest: 0,
        },
      });
    },
    // 修改店铺审核信息
    async htUpdateProfitFee(params) {
      const { union_shop_id } = getState().basic;
      const { selectedRowKeys } = getState().shopPolymerManage;
      const url = selectedRowKeys.length
        ? '/merchant/shop/batcheditstoresettledhtprofitfee'
        : '/merchant/shop/editstoresettledhtprofitfee';
      Object.keys(params).map((item) => {
        if (Number.isNaN(params[item])) {
          params[item] = 0;
        }
        return params[item];
      });
      const result = await fetch(url, {
        type: 'POST',
        params: {
          union_shop_id,
          ...params,
          settled_shop_ids: selectedRowKeys.join(','),
        },
      });
      if (result) {
        if (selectedRowKeys.length) {
          message.success('佣金/费率批量操作成功');
        }
        shopPolymerManage.getList();
      }
    },
    // 修改折扣信息
    async updateCompanyDiscount(params) {
      const newparams = filterNull(params);
      const { union_shop_id } = getState().basic;
      const { selectedRowKeys } = getState().shopPolymerManage;
      const newPar = { unionShopId: union_shop_id, ...newparams };

      const result = await fetch('/saasmerchant/web/shop/editstoresettledcompanydiscount', {
        type: 'POST',
        params: newPar,
        useJson: true,
      });
      if (result) {
        if (selectedRowKeys.length) {
          message.success('企业折扣批量操作成功');
        }
      }
      shopPolymerManage.getList();
    },

    updatedIscountModalVisible(params) {
      shopPolymerManage.setState({ iscountModalVisible: params });
    },
    // 批量设置物流
    async updateSFDelivery(params) {
      const newparams = filterNull(params);
      const { union_shop_id } = getState().basic;
      const { selectedRowKeys } = getState().shopPolymerManage;
      const p = { unionShopId: union_shop_id, ...newparams };
      // if (selectedRowKeys.length) {
      //   p.settled_shop_ids = selectedRowKeys.join(',');
      // }
      const result = await fetch('/saasmerchant/web/shop/unionsetsaaslogistical', {
        type: 'POST',
        params: p,
        useJson: true,
      });
      if (result) {
        if (selectedRowKeys.length) {
          message.success('一站专送批量操作成功');
        }
        shopPolymerManage.getList();
      }
    },

    // 批量设置门店类型
    async postSetShopType(storeType, settledShopInfos, callback) {
      const { union_shop_id } = getState().basic;
      // const { selectedRowKeys } = getState().shopPolymerManage;
      const result = await fetch('/saasmerchant/web/shoplicense/manage/batchSetShopType', {
        type: 'POST',
        useJson: true,
        params: {
          unionShopId: union_shop_id,
          storeType,
          settledShopInfos: settledShopInfos,
        },
      });
      if (result) {
        callback();
        shopPolymerManage.getList();
      }
    },
    setQueryParams(params) {
      const { queryParams } = getState().shopPolymerManage;
      shopPolymerManage.setState({ queryParams: { ...queryParams, ...params } });
    },
    updatedBatchDeliveryModalVisible(params) {
      shopPolymerManage.setState({ batchDeliveryModalVisible: params });
    },
    updatedBatchEditAllModalVisible(params) {
      shopPolymerManage.setState({ batchEditAllModalVisible: params });
    },
    updatedEditFeeModalVisible(params) {
      shopPolymerManage.setState({ editFeeModalVisible: params });
    },
    updateBatchBusinessAttributeModalVisible(visible) {
      shopPolymerManage.setState({
        batchBusinessAttributeModalVisible: visible,
      });
    },
    updateAuditMerchantDeliveryVisible(auditMerchantDeliveryVisible) {
      shopPolymerManage.setState({
        auditMerchantDeliveryVisible,
      });
    },
    updateComplaintRecordVisible(visible) {
      shopPolymerManage.setState({ complaintRecordModalVisible: visible });
    },
    updateLogisticsValuationVisible(visible) {
      shopPolymerManage.setState({ logisticsValuationVisible: visible });
    },
    // 查询商户物流计价规则
    async postShopValuationQuery(shopId, subShopId) {
      const data = await fetch('/saasmerchant/web/bms/fslogistics/subshop/valuationquery', {
        type: 'POST',
        useJson: true,
        params: { shopId, subShopId },
      });
      if (data) {
        shopPolymerManage.setState({ valuationData: data.rules });
      }
    },
    setSelectedItem(subShopId, merchantId) {
      shopPolymerManage.setState({
        selectedItem: {
          subShopId,
          shopId: merchantId,
        },
      });
    },
    async postSubShopValuationQuery() {
      const { selectedItem } = getState().shopPolymerManage;
      const data = await fetch('/saasmerchant/web/bms/fslogistics/subshop/valuationquery', {
        type: 'POST',
        useJson: true,
        params: { ...selectedItem },
      });
      return data;
    },
    // 设置门店物流计价
    async postSetSubShopValuation(params) {
      const data = await fetch('/saasmerchant/web/bms/fslogistics/subshop/valuationset', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success('物流计价配置成功');
        shopPolymerManage.setState({ logisticsValuationVisible: false });
      }
    },

    setEnvironmentVisible() {
      const { environmentVisible } = getState().shopPolymerManage;
      shopPolymerManage.setState({ environmentVisible: !environmentVisible });
    },
    setQuickpayVisible(flag) {
      shopPolymerManage.setState({ quickpaySettingModalVisible: flag });
    },
    async setEnvironmentLabel(params) {
      const { union_shop_id } = getState().basic;
      // const { selectedRowKeys } = getState().shopPolymerManage;
      const data = await fetch('/saasmerchant/web/shoplicense/manage/batchSetStoreEcoLabel', {
        type: 'POST',
        params: {
          unionShopId: union_shop_id,
          // settledShopIds: selectedRowKeys,
          ...params,
        },
        useJson: true,
      });
      if (data) {
        message.success('批量设置成功！');
        shopPolymerManage.setEnvironmentVisible();
        shopPolymerManage.getList();
      }
    },
    // 批量到店付
    async updateQuickpaymanage(params) {
      // const { selectedRowKeys } = getState().shopPolymerManage;
      const data = await fetch('/saasmerchant/web/bms/business/shop/quickpaymanage/update', {
        type: 'POST',
        params: {
          ...params,
          // subShopIdList: selectedRowKeys.length?selectedRowKeys:[params.subShopId],//用来区分是批量还是单条
        },
        useJson: true,
      });
      if (data) {
        message.success('设置成功！');
        shopPolymerManage.setQuickpayVisible(false);
        shopPolymerManage.getList();
      }
      return data;
    },
    changehardWarePage(page, pageSize, subShopId) {
      shopPolymerManage.setState({
        hardWarePageParams: { page, pageSize: 20 },
      });
      shopPolymerManage.getHardWareList(subShopId, { page, pageSize: 20 });
    },
    // 获取硬件绑定列表
    async getHardWareList(subShopId, hardWarePageParams) {
      shopPolymerManage.setState({ hardWareListLoading: true });
      const { shopId } = getState().shopPolymerManage;
      const data = await fetch('/saasmerchant/web/shop/hardware/list', {
        type: 'POST',
        useJson: true,
        params: {
          shopId,
          subShopId,
          ...hardWarePageParams,
        },
      });
      if (data) {
        shopPolymerManage.setState({
          hardWareList: data.list,
          hardWareListTotal: data.total,
          hardWareListLoading: false,
        });
      }
      return data;
    },
    // 获取硬件绑定详情
    async getHardWareDetail(subShopId, hardwareBindId) {
      const { shopId } = getState().shopPolymerManage;
      shopPolymerManage.setState({ bindHardWareLoading: true });
      const data = await fetch('/saasmerchant/web/shop/hardware/bindDetails', {
        type: 'POST',
        useJson: true,
        params: {
          shopId,
          subShopId,
          hardwareBindId,
        },
      });
      if (data) {
        shopPolymerManage.setState({
          hardWareListDetail: data,
          bindHardWareLoading: false,
        });
      }
      return data;
    },
    // 删除硬件
    async deleteHardWare(subShopId, hardwareBindId, id) {
      const { shopId } = getState().shopPolymerManage;
      const { hardWarePageParams } = getState().shopPolymerManage;
      const data = await fetch('/saasmerchant/web/shop/hardware/delete', {
        type: 'POST',
        useJson: true,
        params: {
          shopId,
          subShopId,
          hardwareBindId,
          id,
        },
      });
      if (data) {
        message.success('删除成功');
        shopPolymerManage.getHardWareList(subShopId, hardWarePageParams);
      }
    },
    // 绑定硬件
    async bindHardWare(params) {
      const { shopId } = getState().shopPolymerManage;
      const data = await fetch('/saasmerchant/web/shop/hardware/bind', {
        type: 'POST',
        useJson: true,
        params: {
          shopId,
          ...params,
        },
      });
      if (data) {
        message.success('绑定成功');
      }
      return data;
    },
    async updateAdvertFlag(params) {
      const data = await fetch('/saasmerchant/web/shop/advert/config/update', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('切换成功');
        shopPolymerManage.getList();
      }
      return data;
    },
    setShopId(shopId) {
      shopPolymerManage.setState({ shopId });
    },
    setSubShopId(subShopId) {
      shopPolymerManage.setState({ subShopId });
    },
    /**
     * 获取收款信息
     * @param params subShopId, merchantId
     */
    async getCollectInfo(params) {
      const data = await fetch('/saasmerchant/web/bms/shop/getBillingMessage', {
        type: 'GET',
        useJson: true,
        params,
      });
      return data;
    },
    /**
     * 批量审核
     */
    async onAudit(params) {
      const data = await fetch('/saasmerchant/web/bms/shop/batchVerify', {
        type: 'POST',
        useJson: true,
        params: {
          idList: params,
        },
      });
      if (data) {
        message.success('门店全部审核通过，已上线入驻');
      } else {
        message.warn('门店部分审核驳回，请在列表信息查看驳回原因');
      }
      shopPolymerManage.getList();
    },
    async subShopActivate(params) {
      const data = await fetch('/saasmerchant/web/bms/merchant/subShopActivate', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success('激活成功');
      } else {
        message.error('激活失败');
      }
      shopPolymerManage.getList();
    },
  }),
};

export default model;
